import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    ViewChild,
} from '@angular/core';
import { AppMenuProfileComponent } from './app.menuprofile.component';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
})
/**
 * Sidebar host component that manages hover-triggered expand/collapse.
 *
 * While the sidebar is in non-anchored mode, `onMouseEnter` immediately cancels any pending
 * collapse timeout and sets `sidebarActive = true`; `onMouseLeave` schedules a 300 ms
 * timeout to set `sidebarActive = false`.  `anchor` toggles the pinned state so the sidebar
 * stays open without hover.
 *
 * `resetOverlay` is called from `ngOnDestroy` to clear `overlayMenuActive` and prevent stale
 * state after the component is torn down.
 */
export class AppSidebarComponent implements OnDestroy {
    timeout: any = null;

    @ViewChild(AppMenuProfileComponent) menuProfile!: AppMenuProfileComponent;

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(public layoutService: LayoutService, public el: ElementRef) {}

    /** Clears `overlayMenuActive` state if the overlay is currently open. */
    resetOverlay() {
        if (this.layoutService.state.overlayMenuActive) {
            this.layoutService.state.overlayMenuActive = false;
        }
    }

    /** The configured position of the menu-profile panel (`'start'` or `'end'`). */
    get menuProfilePosition(): string {
        return this.layoutService.config().menuProfilePosition;
    }

    /** Cancels any pending collapse timeout and marks the sidebar as active when not anchored. */
    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;
        }
    }

    /** Schedules a 300 ms timeout to collapse the sidebar when not anchored. */
    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(
                    () => (this.layoutService.state.sidebarActive = false),
                    300
                );
            }
        }
    }

    /** Toggles the anchored/pinned state of the sidebar. */
    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
    }

    /** Calls `resetOverlay` to clear any active overlay state on component teardown. */
    ngOnDestroy() {
        this.resetOverlay();
    }
}
